<template>
  <v-app id="app_bulk_upload">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">BULK UPLOAD MANAGEMENT</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Select a module below to perform a bulk upload.
          </p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-spacer></v-spacer>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-8 px-4">
        <!-- Area Bulk Upload Card -->
        <v-col cols="12" md="4" v-if="canReadRoute('/Create-Area')">
          <v-card class="custom_card_box hover-card" elevation="1" border rounded="lg" @click="navigateTo('/Create-Area')">
            <v-card-text class="pa-6 text-center">
              <v-icon size="64" color="#800080" class="mb-4">mdi-map-marker-multiple</v-icon>
              <h3 class="text-h6 font-weight-bold mb-2">Area Bulk Upload</h3>
              <p class="text-subtitle-2 text-grey">Upload bulk data set for Areas</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4 justify-center">
              <v-btn color="#800080" variant="text" append-icon="mdi-arrow-right">GO TO UPLOAD</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- Dealer Bulk Upload Card -->
        <v-col cols="12" md="4" v-if="canReadRoute('/dealer-registration')">
          <v-card class="custom_card_box hover-card" elevation="1" border rounded="lg" @click="navigateTo('/dealer-registration')">
            <v-card-text class="pa-6 text-center">
              <v-icon size="64" color="#800080" class="mb-4">mdi-storefront-outline</v-icon>
              <h3 class="text-h6 font-weight-bold mb-2">Dealer Bulk Upload</h3>
              <p class="text-subtitle-2 text-grey">Upload bulk data set for Dealers</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4 justify-center">
              <v-btn color="#800080" variant="text" append-icon="mdi-arrow-right">GO TO UPLOAD</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- Collection Bulk Upload Card -->
        <v-col cols="12" md="4" v-if="canReadRoute('/Collection-Bulk-Upload')">
          <v-card class="custom_card_box hover-card" elevation="1" border rounded="lg" @click="navigateTo('/Collection-Bulk-Upload')">
            <v-card-text class="pa-6 text-center">
              <v-icon size="64" color="#800080" class="mb-4">mdi-cash-multiple</v-icon>
              <h3 class="text-h6 font-weight-bold mb-2">Collection Bulk Upload</h3>
              <p class="text-subtitle-2 text-grey">Upload bulk data set for Collections / Outstandings</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4 justify-center">
              <v-btn color="#800080" variant="text" append-icon="mdi-arrow-right">GO TO UPLOAD</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { canAccessRoute } from "@/plugins/permissions";

export default {
  name: "BulkUpload",
  methods: {
    backPageRoute() {
      this.$router.back();
    },
    navigateTo(path) {
      this.$router.push({ path: path, query: { openBulkUpload: 'true' } });
    },
    canReadRoute(routePath) {
      return canAccessRoute(routePath, "read");
    }
  }
}
</script>

<style scoped>
.hover-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.hover-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0,0,0,0.1) !important;
}
</style>
